

























































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { HotKey } from './type'

@Component({
  name: 'HotKeys'
})
export default class HotKeys extends Vue {
  @Prop() hotKeys!: Array<HotKey>

  @Prop({ type: Boolean, default: false }) inheritance!: boolean
}
